import React from 'react';

function getInitials(email: string, givenName?: string, familyName?: string): string {
  if (givenName && familyName) {
    return (givenName[0] + familyName[0]).toUpperCase();
  }
  if (givenName) return givenName[0].toUpperCase();
  const prefix = email.split('@')[0] || '';
  const parts = prefix.split(/[._-]/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return prefix.slice(0, 2).toUpperCase();
}

interface UserAvatarProps {
  email: string;
  pictureUrl?: string;
  givenName?: string;
  familyName?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function UserAvatar({ email, pictureUrl, givenName, familyName, size = 'sm', className = '' }: UserAvatarProps) {
  const sizeClasses = size === 'lg' ? 'w-10 h-10 text-sm' : size === 'md' ? 'w-8 h-8 text-xs' : 'w-6 h-6 text-[10px]';

  if (pictureUrl) {
    return (
      <img
        src={pictureUrl}
        alt={email}
        referrerPolicy="no-referrer"
        className={`${sizeClasses} rounded-full object-cover ${className}`}
      />
    );
  }

  const initials = getInitials(email, givenName, familyName);
  return (
    <div className={`${sizeClasses} rounded-full bg-muted flex items-center justify-center font-medium text-muted-foreground shrink-0 ${className}`}>
      {initials}
    </div>
  );
}
